module.exports = __webpack_public_path__ + "media/customizations/icpnaples/back-7cc4740c8fd54f3e7be401f62e3e001e.jpg";